import { useEffect } from "react";
import { __Lang } from "../../../_core/core";
import { store } from "../../../_core/core.Store";
import { setGameplayData } from "../../../_core/store/slices/slice.Game";
import { BETTING_OPEN_SECONDS } from "../../config/Game";

import "./Draw.timer.styles.css";

interface DrawTimerInterface {
  duration: number;
  drawNumber: number;
}

const DrawTimer = ({ duration, drawNumber }: DrawTimerInterface) => {
  useEffect(() => {
    let startDate = new Date().valueOf();
    let endDate = new Date().valueOf() + duration * 1000;

    let _timer = timerCount(startDate, endDate);
    flipAllCards(_timer);

    const timerInterval = setInterval(() => {
      let _timer = timerCount(startDate, endDate);
      flipAllCards(_timer);
    }, 1000);

    return () => {
      clearInterval(timerInterval);
    };
  }, [duration]);

  return (
    <div className="game-status-wrapper game-status-next">
      <span className="label">
        {__Lang.translate("n:play.newGame")} <b>{drawNumber}</b>
      </span>
      <div className="container">
        <div className="container-segment">
          <div className="segment">
            <div className="flip-card" data-minutes-tens>
              <div className="top">0</div>
              <div className="bottom">0</div>
            </div>
            <div className="flip-card" data-minutes-ones>
              <div className="top">0</div>
              <div className="bottom">0</div>
            </div>
          </div>
        </div>
        <div className="container-segment">
          <div className="segment">
            <div className="flip-card" data-seconds-tens>
              <div className="top">0</div>
              <div className="bottom">0</div>
            </div>
            <div className="flip-card" data-seconds-ones>
              <div className="top">0</div>
              <div className="bottom">0</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function flipAllCards(time: any) {
  if (!time) return;

  const seconds = time.seconds;
  const minutes = time.minutes;

  flip(document.querySelector("[data-minutes-tens]"), Math.floor(minutes / 10));
  flip(document.querySelector("[data-minutes-ones]"), minutes % 10);
  flip(document.querySelector("[data-seconds-tens]"), Math.floor(seconds / 10));
  flip(document.querySelector("[data-seconds-ones]"), seconds % 10);
}

const flip = (flipCard: any, newNumber: number) => {
  const topHalf = flipCard.querySelector(".top");
  const startNumber = parseInt(topHalf.textContent);
  if (newNumber === startNumber) return;

  const bottomHalf = flipCard.querySelector(".bottom");
  const topFlip = document.createElement("div");
  topFlip.classList.add("top-flip");
  const bottomFlip = document.createElement("div");
  bottomFlip.classList.add("bottom-flip");

  // top.textContent = startNumber
  bottomHalf.textContent = startNumber;
  //@ts-ignore
  topFlip.textContent = startNumber;
  //@ts-ignore
  bottomFlip.textContent = newNumber;

  topFlip.addEventListener("animationstart", (e) => {
    topHalf.textContent = newNumber;
  });
  topFlip.addEventListener("animationend", (e) => {
    topFlip.remove();
  });
  bottomFlip.addEventListener("animationend", (e) => {
    bottomHalf.textContent = newNumber;
    bottomFlip.remove();
  });
  flipCard.append(topFlip, bottomFlip);
};

const timerCount = (start: number, end: number) => {
  let now = new Date().valueOf();
  let distance = end - now;

  if (distance > 0) {
    if (distance < BETTING_OPEN_SECONDS * 1000) {
      store.dispatch(
        setGameplayData({
          bettingOpen: false,
        })
      );
    }
    return calcTime(distance);
  }
  if (distance !== 0) {
    if (distance !== 0) {
      store.dispatch(
        setGameplayData({
          timer: 0,
        })
      );
    }
  }
};

const calcTime = (dist: number) => {
  let days = Math.floor(dist / (1000 * 60 * 60 * 24));
  let hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let minutes: any = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
  let seconds: any = Math.floor((dist % (1000 * 60)) / 1000);

  //format seconds & minutes
  if (minutes <= 9) minutes = "0" + minutes;
  if (seconds <= 9) seconds = "0" + seconds;

  return { days, hours, minutes, seconds };
};

export default DrawTimer;
